const styles = {
  modal: {
    borderRadius: 3,
    backgroundColor: 'white',
    padding: 5,
  },
  headerLabel: {
    marginBottom: 3,
  },
  formError: {
    marginBottom: 3,
  },
  textField: {
    marginBottom: 2,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 2,
    paddingTop: 3,
  },
  cancelButton: {
    marginRight: 3,
  },
  progress: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 1,
    marginBottom: 2,
  },
  progressLabel: {
    color: 'text.secondary',
  },
  secondaryButton: {
    backgroundColor: 'gray',
    padding: 10,
    margin: 5,
  },
  feedback: {
    marginBottom: 2,
  },
}

export default styles
